export default __webpack_public_path__ + "static/sellerp-97877fb882fc3a71c7b6b5b58bc663b0.png";